import { Component, Input } from "@angular/core";
import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";

@Component({
    selector: "app-nav-item-loader",
    imports: [NgxSkeletonLoaderModule],
    templateUrl: "./nav-item-loader.component.html",
    styleUrl: "./nav-item-loader.component.scss"
})
export class NavItemLoaderComponent {
  @Input() show: boolean | null = false;
  protected readonly Array = Array;
}
